import styled, { keyframes } from "styled-components";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  } to {
    transform: rotate(360deg);
  }
`;

const fade = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  margin-top: 0.3rem;

  animation: ${fade} 0.2s linear forwards;

  &.error {
    color: var(--input-error);
  }
`;

export const Error = styled(Container)``;

export const Verifying = styled(Container)`
  display: flex;
  align-items: center;

  color: var(--input-verifying);

  i {
    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 0.3rem;

    animation: ${spin} 1.5s infinite linear;

    svg path {
      stroke: var(--input-verifying);
    }
  }
`;
